import { Button, Label, TextInput } from "flowbite-react";

export default function PropertyMediaQueueGrid({
  items,
  labelPlaceholder,
  onChangeLabel,
  onRemove,
}) {
  if (!items.length) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
      {items.map((item) => (
        <div
          key={item.id}
          className="border border-gray-200 dark:border-gray-800 rounded-lg p-3 bg-white dark:bg-gray-900"
        >
          <img
            src={item.previewUrl}
            alt={item.label || "preview"}
            className="w-full h-40 object-cover rounded-md"
          />

          <div className="mt-2 space-y-2">
            <div>
              <Label>Label</Label>
              <TextInput
                value={item.label}
                onChange={(event) => onChangeLabel(item.id, event.target.value)}
                placeholder={labelPlaceholder}
              />
            </div>

            <div className="flex justify-end">
              <Button color="failure" size="xs" onClick={() => onRemove(item.id)}>
                Remover
              </Button>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
